import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getBackofficeCustomersQueryKey } from "modules/backoffice/lib/customers/getBackofficeCustomersQuery"
import { DataResponse, UpsertBackofficeCustomerBodySchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof UpsertBackofficeCustomerBodySchema>>

type Props = {
  onSuccess?: () => void
}

export function useCreateBackofficeCustomerMutation({ onSuccess }: Props = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.input<typeof UpsertBackofficeCustomerBodySchema>) => {
      const response = await axios.post<Response>(`/backoffice/customers`, data)

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBackofficeCustomersQueryKey() })

      onSuccess?.()
    },
  })
}
